import './index.scss'
import { initApp, setActiveNav } from 'app/js/app'

$(() => {
      initApp()
      initialize()
})

function drawMap(map, point, marker, searchInfoWindow) {
      map.centerAndZoom(point, 14)
      map.addOverlay(marker)
      map.enableScrollWheelZoom()
      marker.setAnimation(BMAP_ANIMATION_BOUNCE)
      setTimeout(() => {
          map.addOverlay(marker)
          marker.setAnimation()
          map.setZoom(16)
      }, 2000)
}

function initialize() {
      var map = new BMap.Map("map")
      // BD-09: Global Trade Center (GTC)
      var point = new BMap.Point(116.41798, 39.96771)
      var marker = new BMap.Marker(point)
      var content = '<div style="margin:0;line-height:20px;">' +
          'Global Trade Center (GTC)<br/>' +
          'No. 36 North Third Ring Road East, Dongcheng District, Beijing<br/>' +
          'Room 813, 8/F, Building 3 (Tower E)' +
          '</div>'
      var searchInfoWindow = null
      drawMap(map, point, marker, searchInfoWindow)
      marker.addEventListener("click", function () {
                var infoWindow = new BMap.InfoWindow(content)
                map.openInfoWindow(infoWindow, point)
                marker.setAnimation()
            })
      map.addOverlay(marker)

}



// WEBPACK FOOTER //
// ./src/en/us/index.js